import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { removeFormSet, RemoveFormSetAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useRemoveFormSet(): LocalOperation<
	(payload: ActionPayload<RemoveFormSetAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<RemoveFormSetAction>) {
		dispatch(removeFormSet(payload));
	}

	return handler;
}
